<template>
  <div class="main">
    <div class="row header-box">
      <div class="col-md-12">
        <div class="container">
          <div class="pull-left">
            <img class="logo-promo" src="../../../static/logo-promo-relampago.svg" alt="">
          </div>
          <div class="pull-right">
            <img class="logo-mm" src="../../../static/logo-movemais-promo-header.svg" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="container margin-t20 economic-plan">
          <div class="pull-left plan-box">
            <h1 class="bold text-center margin-b20">PLANO ECONÔMICO</h1>
            <span class="text-yellow bold-600">Vantagens:</span>
            <ul>
              <li>
                <img class="icon-bolt" src="../../../static/icon-bolt.svg" alt="">
                Plano Pré-pago sem taxa de adesão
              </li>
              <li>
                <img class="icon-bolt" src="../../../static/icon-bolt.svg" alt="">
                Receba sua(s) TAG(s) em casa, com frete grátis
              </li>
              <li>
                <img class="icon-bolt" src="../../../static/icon-bolt.svg" alt="">
                R$ 25,00 ou mais para aderir
              </li>
              <li>
                <img class="icon-bolt" src="../../../static/icon-bolt.svg" alt="">
                A primeira taxa de recarga é grátis
              </li>
              <li>
                <img class="icon-bolt" src="../../../static/icon-bolt.svg" alt="">
                Receba seu dinheiro em crédito para utilização
              </li>
            </ul>
          </div>
          <div class="pull-right">
            <img class="icon-bolt-money" src="../../../static/img-promo-bolt-saving-money2.svg" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="container options-box">
          <div class="pull-left bolt-option-box">
            <img class="icon-bolt-option" src="../../../static/img-promo-bolt-pre-pays-option.svg" alt="">
          </div>
          <div class="pull-right button-box">
            <h4 class="text-center">Temos duas modalidades do plano,<br> selecione a melhor para você:</h4>
            <button class="btn btn-warning margin-20 bold-600" :class="{'disabled':isLoadPromo}" @click="choose(economicoManual)">
              Econômico Manual
              <i class="icon-circle-right align-icon-right"></i>
            </button>
            <button class="btn btn-warning bold-600" :class="{'disabled':isLoadPromo}" @click="choose(economicoAuto)">
              Econômico Automático
              <i class="icon-circle-right align-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="container margin-b80 faq-box">
          <h2 class="text-yellow bold">Dúvidas?</h2>
          <hr>
          <h4>
            Para tirar dúvidas ou saber mais informações sobre o plano, basta entrar em contato com a nossa Central de
            Relacionamento nos telefones <b>4000 2901</b> (Capitais e regiões metropolitanas) ou <b>0800 777 1022</b> (demais localidades).
          </h4>
          <h4>Você também pode tirar suas dúvidas no nosso FAQ:</h4>

          <div class="question-box margin-20">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Quanto custa a adesão do Plano Econômico?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                A taxa de adesão e o envio da(s) TAG(s) são grátis neste plano, você só irá investir o valor da
                primeira recarga (que é necessária no ato da adesão), porém a primeira recarga será sem nenhuma taxa,
                ou seja, você irá utilizar o valor total nas passagens de pedágio. O valor mínimo de recarga para este
                plano é R$ 25,00 reais, mas você é livre para fazer uma recarga de maior valor.
              </h4>
            </div>
          </div>

          <div class="question-box margin-b20">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Existe cobrança de mensalidade?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                Não, este plano não tem mensalidade.
              </h4>
            </div>
          </div>

          <!-- <div class="question-box margin-b20">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Onde posso usar? Em qual cidade ou estado?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                Você pode utilizar em todo território nacional, para saber as estradas e rodovias atendidas veja nossa
                cobertura completa, acesse: Cobertura.
              </h4>
            </div>
          </div> -->

          <div class="question-box margin-b20">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Pré-pago Manual ou Pré-pago Automático, qual escolho?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                Se você deseja ter controle total sobre os custos vá de Econômico Manual, se você não quer se preocupar
                com recargas ou saldo insuficiente, vá de Econômico Automático.
              </h4>
            </div>
          </div>

          <div class="question-box margin-b20">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Tem limite de veículos?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                Não, você pode incluir quantos veículos quiser.
              </h4>
            </div>
          </div>

          <div class="question-box">
            <div class="accordion-click">
              <h4 class="bold-600">
                <i class="icon-arrow-major-breadcrumb"></i>
                Pessoa Jurídica pode escolher esse plano?
              </h4>
            </div>
            <div class="answer-box">
              <h4 class="bold-600">
                Não, este plano é destinado somente a pessoas físicas.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade in" id="messageDialog" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title bold text-center">TEMPO ESGOTADO!</h1>
          </div>
          <div class="modal-body">
            <div class="pull-left bolt-option-box">
              <img class="icon-bolt-option" src="../../../static/img-promo-bolt-chronometer.svg" alt="">
            </div>
            <div class="text-center pull-right">
              <h3 class="bold-600 margin-30">Infelizmente essa promoção <br> não está mais disponível.</h3>
              <h4 class="margin-t10">Veja nossos outros planos:</h4>
              <!-- <router-link :to="{name: 'services-b2c'}" id="otherPlans" class="btn btn-warning bold-600 margin-t10" tag="a" @click="closeModal()">Ver outros planos</router-link> -->
              <a href="#/servicos-b2c" class="btn btn-warning bold-600 margin-t10" @click="closeModal()">Ver outros planos</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .main {
    overflow-y:                         overlay;
  }
  .modal-dialog {
    width:                              725px;
    margin-top:                         10vh;
  }
  .modal {
    /* background-color:                   rgba(60,25,70,.8) !important; */
    background-color:                   rgba(0,0,0,.9) !important;
  }
  .modal-header {
    padding:                            0;
    border:                             0;
  }
  .modal-title {
    color:                              #ffd05a;
    background-color:                   #6b1f74;
    padding:                            25px 15px;
    font-size:                          2em;
    -webkit-border-radius:              10px 10px 0 0;
    -moz-border-radius:                 10px 10px 0 0;
    -ms-border-radius:                  10px 10px 0 0;
    -o-border-radius:                   10px 10px 0 0;
    border-radius:                      10px 10px 0 0;
  }
  .modal-body {
    -webkit-border-radius:              0 0 10px 10px;
    -moz-border-radius:                 0 0 10px 10px;
    -ms-border-radius:                  0 0 10px 10px;
    -o-border-radius:                   0 0 10px 10px;
    border-radius:                      0 0 10px 10px;
    padding-left:                       0;
    .icon-bolt-option {
      width:                            300px;
    }
    .text-center.pull-right {
      width:                            390px;
      padding-right:                    50px;
      margin-top:                       20px;
    }
  }

  hr {
    border-color:                       rgba(0, 0, 0, 0.2) !important;
    border-width:                       1.5px !important;
  }
  .main, .modal-body {
    background-color:                   rgb(117, 32, 143);
    color:                              white;
  }
  .text-yellow {
    color:                              #FCCE01;
    &:hover,
    &:focus,
    &:active,
    &:visited {
      color:                            #FCCE01;
    }
  }
  .plan-box {
    width:                              48%;
    margin-top:                         15vh;
    span {
      font-size:                        1.6em;
    }
    ul {
      margin-top:                       10px;
      font-size:                        1.5em;
    }
  }
  .icon-bolt {
    width:                              20px;
  }
  .header-box {
    display:                            block;
    background-color:                   #522066;
    min-height:                         120px;
    padding-top:                        30px;
    .logo-promo {
      width:                            600px;
      /* width: 40vw; */
    }
    .logo-mm {
      width:                            300px;
      /* width: 20vw; */
    }
  }
  .options-box {
    margin-top:                         -50px;
  }
  .button-box {
    width:                              35%;
    margin:                             18vh 5vh;
  }
  .btn-warning {
    width:                              100%;
    font-size:                          1.3em !important;
    i {
      right:                            -50 !important;
    }
  }
  .icon-bolt-money {
    /* width: 600px; */
    width:                              34vw;
  }
  .icon-bolt-option {
    width:                              34vw;
  }

  .answer-box {
    max-height:                         1px;
    overflow:                           hidden;
    padding:                            0 15px;
    p {
      padding:                          10px 20px;
    }
    &.open {
      background-color:                 white;
      color:                            rgb(117, 32, 143);
      max-height:                       100%;
      -o-transition:                    max-height .8s ease-in;
      -ms-transition:                   max-height .8s ease-in;
      -moz-transition:                  max-height .8s ease-in;
      transition:                       max-height .8s ease-in;
      -webkit-border-radius:            0 0 6px 6px;
      -moz-border-radius:               0 0 6px 6px;
      -ms-border-radius:                0 0 6px 6px;
      -o-border-radius:                 0 0 6px 6px;
      border-radius:                    0 0 6px 6px;
    }
  }

  .question-box {
    border:                             2px solid #FFF;
    -webkit-border-radius:              10px;
    -moz-border-radius:                 10px;
    -ms-border-radius:                  10px;
    -o-border-radius:                   10px;
    border-radius:                      10px;
    .accordion-click {
      padding:                          15px;
      h4 {
        padding:                        1em;
        margin:                         -1em;
        line-height:                    22px;
        cursor:                         pointer;
        cursor:                         hand;
      }
    }
  }

  .icon-arrow-major-breadcrumb {
    font-size:                          1em !important;
    display:                            inline-block;
    color:                              white !important;
    -o-transition:                      .4s;
    -ms-transition:                     .4s;
    -moz-transition:                    .4s;
    transition:                         .4s;
    &.open {
      -ms-transform:                    rotate(90deg);
      -webkit-transform:                rotate(90deg);
      transform:                        rotate(90deg);
    }
  }

  @media (max-width: 570px) {
    .header-box {
      .logo-promo {
        width:                          85%;
        margin-bottom:                  10px;
      }
      .logo-mm {
        width:                          150px;
      }
    }
    .economic-plan {
      h1 {
        text-align:                     center;
        font-size:                      2em;
      }
      ul, span {
        padding-left:                   0;
      }
      span {
        font-size:                      1.3em;
      }
      ul {
        font-size:                      1em;
      }
      .icon-bolt {
        width:                          15px;
      }
    }
    .button-box {
      padding:                          0;
      .btn-warning {
        padding:                        10px !important;
        text-align:                     center !important;
        i {
          display:                      none;
        }
      }
      .btn-warning, h4 {
        font-size:                      1.1em !important;
      }
    }
  }

  @media (max-width: 766px) {
    .modal-dialog {
      width:                            320px;
      margin:                           20px auto;
      .bolt-option-box {
        display:                        none;
      }
      .modal-body .text-center.pull-right {
        padding-right:                  0;
        margin:                         20px 0;
        width:                          290px;
      }
    }
    .header-box {
      text-align:                       center;
      padding-bottom:                   25px;
      div {
        float:                          none !important;
      }
      .logo-mm {
        width:                          200px;
        /* width: 20vw; */
      }
    }
    .economic-plan {
      div {
        float:                          none !important;
        width:                          100%;
        margin:                         20px auto;
        h1 {
          text-align:                   center;
        }
        &:last-child {
          text-align:                   center;
          img {
            width:                      300px;
          }
        }
      }
      ul, span {
        padding:                        0;
      }
    }
    .options-box {
      margin:                           0px 0 20px 0;
      padding:                          0;
      div:last-child {
        float:                          none !important;
      }
      .bolt-option-box {
        display:                        none;
      }
      .button-box {
        width:                          100%;
        margin:                         0;
        padding:                        0 15px;
        text-align:                     center;
      }
    }
    .faq-box {
      margin-left:                      0;
      margin-right:                     0;
      h1 {
        font-size:                      1.5em;
      }
      h3 {
        font-size:                      1.2em;
      }
      h4 {
        font-size:                      1.1em;
        line-height:                    1.4em;
      }
    }
  }

  @media screen and (min-width: 571px) and (max-width: 767px) {
    .header-box {
      .logo-promo {
        width:                          80%;
        margin-bottom:                  10px;
      }
    }
    .options-box, .button-box {
      margin:                           0;
      padding:                          0;
    }
    .faq-box {
      padding:                          15px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .icon-bolt {
      width:                            15px;
    }
    .header-box {
      text-align:                       center;
      padding-bottom:                   25px;
      div {
        float:                          none !important;
      }
      .logo-promo {
        width:                          600px;
      }
      .logo-mm {
        width:                          300px;
      }
    }
    .plan-box {
      width:                            47%;
      margin-bottom:                    10px;
      margin-top:                       0;
      h1 {
        font-size:                      2em;
      }
      span {
        font-size:                      1.2em;
      }
      ul {
        font-size:                      1em;
      }
    }
    .button-box {
      width:                            47%;
      margin:                           5vh 0;
      .btn-yellow {
        padding:                        10px 56px 10px 50px !important;
        &:last-child {
          padding:                      10px 57px 10px 27px;
        }
      }
      .btn-warning, h4 {
        font-size:                      1.1em !important;
      }
    }
    .faq-box {
      h1 {
        font-size:                      1.5em;
      }
      h3 {
        font-size:                      1.2em;
      }
      h4 {
        font-size:                      1.1em;
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .btn-warning {
      padding:                          10px 55px 10px 45px !important;
    }
    .plan-box {
      width:                            50%;
      margin-bottom:                    10px;
      margin-top:                       5vh;
      padding-left:                     5%;
      span, ul {
        font-size:                      1.2em;
      }
    }
    .options-box {
      margin-top:                       0;
    }
    .button-box {
      margin:                           5vh 10vh;
    }
  }

  @media screen and (min-width: 1200px) and (max-width: 1599px) {
    .plan-box {
      margin:                           5vh;
    }
    .button-box {
      margin:                           9vh;
    }
    .icon-bolt-money {
      width:                            50vh;
    }
  }

  @media (min-width: 1600px) {
    .plan-box {
      width:                            520px;
    }
    .icon-bolt-money,
    .icon-bolt-option {
      width:                            600px;
    }
  }
</style>
<script type="text/javascript">
import Sales from '../../services/sales'
import {EventBus} from '../../event-bus'
import Moment from 'moment'

export default {
  data(){
    return {
      economicoManual: undefined,
      economicoAuto: undefined,
      filter: undefined,
      loadPromo:true,
    }
  },
  computed:{
    isLoadPromo(){
      return this.loadPromo;
    }
  },
  beforeMount(){
    this.hasPromotion();
  },
  mounted(){
    let el = $(this.$el);
    el.find('.question-box .accordion-click').click(function(){
      el.find('.open').removeClass('open');
      $(this).find('i').addClass('open');
      $(this).parent().find('.answer-box').addClass('open');
    });
    Sales.getPlan().then(response=>{
      this.economicoAuto=response.find(e=>e.name.indexOf('Automático Econômico')>=0).planId;
      this.economicoManual=response.find(e=>e.name.indexOf('Manual Econômico')>=0).planId;
    })
  },
  methods:{
    choose(planId){
      if(this.type=='newContract'){
        EventBus.$emit('chooseNewPlan', planId);
      } else {
        this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
      }
    },
    hasPromotion(){
     this.loadPromo = Sales.hasPromotion({promotionCode:'PROMO25'}).then(response => {
        let promo = response[0];



          if(promo){
            let  dataIniTime = new Date(promo.start_date).getTime();
            let  dataEndTime = new Date(promo.end_date).getTime();
            let  dataNowTime = new Date().getTime();

            if ( ((dataNowTime >= dataIniTime && dataNowTime < dataEndTime) || (promo.adhesion_count < promo.usage_limit))) {
                $('#messageDialog').modal('hide');
                $('body').css('overflow-y', 'overlay');
                this.loadPromo = false;
            } else {
              $('#messageDialog').modal('show');
              $('body').css('padding-right', '0');
              $('body').css('overflow-y', 'overlay');
            }
          }
      }
      );
    },
    closeModal(){
      $('#messageDialog').modal('hide');
      $('body').removeClass('modal-active');
    }
  }
}
</script>



// WEBPACK FOOTER //
// promo-bolt.vue?0bc90c53